/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Aroma_UpdatedInputs */

const en_aroma_updated = /** @type {(inputs: Aroma_UpdatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aroma updated`)
};

const es_aroma_updated = /** @type {(inputs: Aroma_UpdatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aroma actualizado`)
};

/**
* | output |
* | --- |
* | "Aroma updated" |
*
* @param {Aroma_UpdatedInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const aroma_updated = /** @type {((inputs?: Aroma_UpdatedInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Aroma_UpdatedInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_aroma_updated(inputs)
	return es_aroma_updated(inputs)
});